export default "__VITE_ASSET__B_ZddH$7__"